import * as XLSX from "xlsx";
import styled from "styled-components";

const Button = styled.td`
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  background-color: #ccc;
  color: white;
  border-radius: 5px;
  width: 50px;
  text-align: center;
  align-items: center;
  height: 20px;
`;

const GerarExcel = ({ filtrandoCards = [], verQuadro, colunas = [] }) => {
    const opcoesSituacao = {
        AF: "A Fazer",
        PR: "Programado",
        AN: "Em Andamento",
        VA: "Em Validação",
        PA: "Pausado",
        CO: "Concluído",
        CA: "Cancelado",
        AR: "Arquivado",
    };

    const colunasParaImprimir = colunas?.filter(
        (coluna) => coluna.ID_QUADRO === verQuadro?.ID_QUADRO
    );

    const gerarExcel = () => {
        if (!Array.isArray(colunasParaImprimir) || !Array.isArray(filtrandoCards)) {
            console.error("Erro: os dados fornecidos não são arrays.");
            return;
        }

        const data = [];

        colunasParaImprimir.forEach((coluna) => {
            // Cabeçalho da lista
            data.push({
                "Lista": coluna.DESCRICAO_LISTA,
                "Título do Cartão": "",
                "Descrição": "",
                "Situação": "",
                "Criado em": "",
                "Concluído em": "",
                "Criador": "",
                "Responsável": "",
            });

            const cardsDaColuna = filtrandoCards.filter(
                (card) => card.ID_LISTA === coluna.ID_LISTA
            );

            if (cardsDaColuna.length > 0) {
                cardsDaColuna.forEach((card) => {
                    data.push({
                        "Lista": "",
                        "Título do Cartão": card.TITULO_CARTAO || "-",
                        "Descrição": card.DESCRICAO_CARTAO || "-",
                        "Situação": opcoesSituacao[card.SITUACAO] || card.SITUACAO || "-",
                        "Criado em": card.DATA_CRIACAO || "-",
                        "Concluído em": card.DATA_CONCLUSAO || "-",
                        "Criador": card.NOME_CRIADOR || "-",
                        "Responsável": card.NOME_RESPONSAVEL || "-",
                    });
                });
            } else {
                data.push({
                    "Lista": "",
                    "Título do Cartão": "Nenhum cartão nesta lista",
                    "Descrição": "",
                    "Situação": "",
                    "Criado em": "",
                    "Concluído em": "",
                    "Criador": "",
                    "Responsável": "",
                });
            }
        });

        // Resumo por situação
        const statusContagem = {};
        filtrandoCards.forEach((card) => {
            const status = opcoesSituacao[card.SITUACAO] || card.SITUACAO || "Não definido";
            statusContagem[status] = (statusContagem[status] || 0) + 1;
        });

        data.push({});
        data.push({ "Título do Cartão": "Resumo por Situação:" });

        Object.entries(statusContagem).forEach(([status, count]) => {
            data.push({ "Título do Cartão": `${status}:`, "Descrição": count });
        });

        data.push({});
        data.push({ "Título do Cartão": "Total de cartões:", "Descrição": filtrandoCards.length });

        const ws = XLSX.utils.json_to_sheet(data, { skipHeader: false });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Relatório");

        XLSX.writeFile(wb, `relatorio_${verQuadro?.TITULO_QUADRO || "quadro"}.xlsx`);
    };

    return <Button onClick={gerarExcel}>Excel</Button>;
};

export default GerarExcel;
